import Vue from "vue";
import Vuex from "vuex";
import sideBarStore from "./state/modules/sideBarStore.js"

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    sideBarStore
  }
});
